import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { getSTATUS_OPTIONS } from '../StatusDropdown'
import CheckboxInput from '../../../../../../components/form/CheckboxInput'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../../../packages/kiti/components/form/Select'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')

  const STATUS_OPTIONS = getSTATUS_OPTIONS(t)

  return (
    <>
      <Col width="100%">
        <FormItem
          label={t('widgets.initialPerspective')}
          path={['data', 'initialState', 'status']}
          Input={Select}
          options={STATUS_OPTIONS}
          disableEmptyOption
        />
      </Col>

      <Col width="100%">
        <FormItem
          label={t('widgets.hidePerspectiveSelection')}
          path={['data', 'hideStatusDropdown']}
          Input={CheckboxInput}
          ignoreLabel
        />
      </Col>
    </>
  )
}

export default EditWidgetForm
